import { Container } from 'inversify';
import {
  API_USER_FORGOT_PASSWORD_NAME,
  API_USER_LOGIN_NAME,
  API_USER_REGISTRATION_NAME, API_USER_RESET_PASSWORD_NAME, getApiUserForgotPassword,
  getApiUserLogin,
  getApiUserRegistration, getApiUserResetPassword,
} from '@edikk-edikk/country-frontend';
import { API_BASE_NAME } from '#base/constants';
import { getApiBase } from '#base/api/api-base';
import { API_REVIEW_LIST_NAME } from '#reviewList/constants';
import { API_ADVERT_LIST_BY_DATE_NAME, API_ADVERT_LIST_BY_SERVICE_NAME } from '#advertList/constants';
import { getApiReviewList } from '#reviewList/api/api-review-list';
import { getApiAdvertListByDate } from '#advertList/api/by-date';
import { getApiAdvertListByService } from '#advertList/api/by-service';
import { API_PAGE_NAME } from '#page/constants';
import { getApiPage } from '#page/api';
import { API_ADVERT_REVIEW_CHECK_NAME } from '#reviewCheck/constants';
import { getApiAdvertReviewCheck } from '#reviewCheck/api';
import { API_ADVERT_DETAIL_NAME } from '#advertDetail/constants';
import { getApiAdvertDetail } from '#advertDetail/api';
import { getApiHome } from '#home/api';
import { API_HOME_NAME } from '#home/constants';
import { API_ADVERT_FAVORITE_NAME } from '#advertFavorite/constants';
import { getApiAdvertFavorite } from '#advertFavorite/api';
import { API_LANGUAGE_MODAL_NAME } from '#baseLanguageModal/constants';
import { getApiLanguageModal } from '#baseLanguageModal/api';

class Api {
  private readonly apiList = new Map();

  constructor(private readonly diContainer: Container) {
    this.apiList.set(API_BASE_NAME, getApiBase(this.diContainer));
    this.apiList.set(API_HOME_NAME, getApiHome(this.diContainer));
    this.apiList.set(API_ADVERT_DETAIL_NAME, getApiAdvertDetail(diContainer));
    this.apiList.set(API_ADVERT_REVIEW_CHECK_NAME, getApiAdvertReviewCheck(diContainer));
    this.apiList.set(API_ADVERT_FAVORITE_NAME, getApiAdvertFavorite(diContainer));
    this.apiList.set(API_LANGUAGE_MODAL_NAME, getApiLanguageModal(diContainer));
    this.apiList.set(API_REVIEW_LIST_NAME, getApiReviewList(this.diContainer));
    this.apiList.set(API_ADVERT_LIST_BY_DATE_NAME, getApiAdvertListByDate(this.diContainer));
    this.apiList.set(API_ADVERT_LIST_BY_SERVICE_NAME, getApiAdvertListByService(this.diContainer));
    this.apiList.set(API_PAGE_NAME, getApiPage(this.diContainer));
    this.apiList.set(API_USER_LOGIN_NAME, getApiUserLogin(this.diContainer));
    this.apiList.set(API_USER_REGISTRATION_NAME, getApiUserRegistration(this.diContainer));
    this.apiList.set(API_USER_FORGOT_PASSWORD_NAME, getApiUserForgotPassword(this.diContainer));
    this.apiList.set(API_USER_RESET_PASSWORD_NAME, getApiUserResetPassword(this.diContainer));
  }

  getApiHome(): ReturnType<typeof getApiHome> {
    return this.apiList.get(API_HOME_NAME);
  }

  getApiAdvertDetail(): ReturnType<typeof getApiAdvertDetail> {
    return this.apiList.get(API_ADVERT_DETAIL_NAME);
  }

  getApiAdvertReviewCheck(): ReturnType<typeof getApiAdvertReviewCheck> {
    return this.apiList.get(API_ADVERT_REVIEW_CHECK_NAME);
  }

  getApiAdvertFavorite(): ReturnType<typeof getApiAdvertFavorite> {
    return this.apiList.get(API_ADVERT_FAVORITE_NAME);
  }

  getApiLanguageModal(): ReturnType<typeof getApiLanguageModal> {
    return this.apiList.get(API_LANGUAGE_MODAL_NAME);
  }

  getApiBase(): ReturnType<typeof getApiBase> {
    return this.apiList.get(API_BASE_NAME);
  }

  getApiReviewList(): ReturnType<typeof getApiReviewList> {
    return this.apiList.get(API_REVIEW_LIST_NAME);
  }

  getApiAdvertListByDate(): ReturnType<typeof getApiAdvertListByDate> {
    return this.apiList.get(API_ADVERT_LIST_BY_DATE_NAME);
  }

  getApiAdvertListByService(): ReturnType<typeof getApiAdvertListByService> {
    return this.apiList.get(API_ADVERT_LIST_BY_SERVICE_NAME);
  }

  getApiPage(): ReturnType<typeof getApiPage> {
    return this.apiList.get(API_PAGE_NAME);
  }

  getApiUserLogin(): ReturnType<typeof getApiUserLogin> {
    return this.apiList.get(API_USER_LOGIN_NAME);
  }

  getApiUserRegistration(): ReturnType<typeof getApiUserRegistration> {
    return this.apiList.get(API_USER_REGISTRATION_NAME);
  }

  getApiUserForgotPassword(): ReturnType<typeof getApiUserForgotPassword> {
    return this.apiList.get(API_USER_FORGOT_PASSWORD_NAME);
  }

  getApiUserResetPassword(): ReturnType<typeof getApiUserResetPassword> {
    return this.apiList.get(API_USER_RESET_PASSWORD_NAME);
  }
}

export { Api };
